// extracted by mini-css-extract-plugin
export default {"root":"Register_root__upd2S"};